import { ConcreteEncodable } from "./ConcreteEncodable";

import { ControllEventImplEncoder } from "../../encoder/ControllEventImplEncoder";

import * as CubiqTS from "../../index";
import { ControllEvent } from "../ControllEvent";

export class ControllEventImpl extends ConcreteEncodable implements ControllEvent {
  public static enType: string = "com.bcdfx.streaming.ControllEventImpl";

  /*FID=1*/
  public type: CubiqTS.ControlEventType;
  /*FID=2*/
  public providerId: number;
  /*FID=3*/
  public providerCode: string;
  /*FID=4*/
  public items: Array<CubiqTS.ControlItem> | null = null;
  /*FID=5*/
  public isAutoFailOver: boolean;
  /*FID=100*/
  public messageId: string;
  public sessionOnly: string;

  constructor() {
    super();
    this.encoder = ControllEventImplEncoder.Instance;
    this.setEncodableType(ControllEventImpl.enType);
    //Model
  }

  public toString(): string {
    return (
      "ControllEventImpl[" +
      "type=" +
      this.type +
      "providerId=" +
      this.providerId +
      "providerCode=" +
      this.providerCode +
      "items=" +
      this.items +
      "isAutoFailOver=" +
      this.isAutoFailOver +
      "messageId=" +
      this.messageId +
      "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
